export default __webpack_public_path__ + "static/media/image.agile-financial.37118046.png";